<template><div class="view">

	<main>

		<div id="my-casting" v-if="casting">

			<div id="form-elements" v-if="casting">
			
				<div class="grid">
					<div class="col m33">
				
						<div class="field">
							<label>Title</label>
							<input type="text" :value="casting.title" ref="title" @change="updateCasting()">
						</div>

						<div class="field">
							<label>Your name</label>
							<input type="text" ref="from_name" :value="casting.from_name" @change="updateCasting()" autocomplete="name">
						</div>

						<div class="field">
							<label>Your email</label>
							<input type="text" ref="from_email" :value="casting.from_email" @change="updateCasting()">
						</div>					

						<a v-if="casting.uid" class="package-linker" :href="site_base_url + 'package/' + casting.uid" target="_blank">
							Package link: <br>
							{{site_base_url}}package/{{casting.uid}}
						</a>

					</div>
					<div class="col m34">
				
						<div class="field">
							<label>Recipient name</label>
							<input type="text" ref="to_name" :value="casting.to_name" @change="updateCasting()" autocomplete="name">
						</div>
						
						<div class="field">
							<label>Recipient email</label>
							<input type="text" ref="to_email" :value="casting.to_email" @change="updateCasting()">
						</div>
						
						<div class="field">
							<label>Notes</label>
							<textarea name="" ref="notes" :value="casting.notes" rows="5" @change="updateCasting()"></textarea>
						</div>

					</div>				
					<div class="col m33">

						<div class="btns-ui">

							<div class="field" :key="'castingselector'+castings.length">
								<label>My packages</label>
								<select :value="casting_active_index" ref="castingselector" @change="selectCastingFromList($event)">
									<option :value="c_i" v-for="(c,c_i) in castings">{{c.title}}</option>
								</select>
								<div class="select-arrow">&#9662;</div>
							</div>
							
							<div class="btn btn-full btn-white shadowed" @click="saveCastingClick()">Save package</div>
							<div class="btn btn-full btn-white shadowed hide" @click="printCastingClick()">Print package</div>
							<div class="btn btn-full btn-white shadowed" @click="createNewCastingClick()">Create new package</div>
							<div class="btn btn-full btn-white shadowed" @click="removeCastingClick()">Remove package</div>
							<div class="btn btn-full btn-white shadowed" @click="doCopy()">Copy package link</div>				
							<div class="btn btn-full btn-white shadowed" @click="importCasting()">Add existing package</div>				
							<div class="btn btn-full btn-black" v-if="casting && casting.items && casting.items.length" @click="sendCastingClick()">Send package as email</div>

						</div>

					</div>					
				</div>				

			</div>

			<casting-items-list 
				v-if="casting && casting.items"
				:itemgroups="active_casting_items_with_metadata_grouped"
				:can-remove-items="true"
				itemGroupActionBtnLabel="Remove"
				@removeItem="removeItem"
				@removeItemGroup="removeItemGroup"
			/>

			<div v-if="casting && casting.items && !casting.items.length">
				<br><br>
				Your package is empty. Find some content and click 'Add to Package'.
			</div>

		</div>
			
	</main>

</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import axios from 'axios'; import qs from 'qs'

import CastingItemsList from '.././components/CastingItemsList'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		CastingItemsList
	},

	data(){ return {
		
		ready: false,
		message: undefined,

		sending_to_email: undefined,

		active_casting_items_with_metadata: undefined,

		casting_server_loaded: undefined,

		mode_view_loaded_package: undefined,

	}},

	computed: {

		casting_active_index(){  return this.$store.state.casting_active_index },
		casting(){ return this.$store.state.castings[this.$store.state.casting_active_index] },
		castings(){ return this.$store.state.castings },


		active_casting_items_with_metadata_grouped(){

			if( !this.active_casting_items_with_metadata ) return
			var items = JSON.parse(JSON.stringify(this.active_casting_items_with_metadata))
			return helpers.casting_items_groupify(items)

		},

	},

	methods: {

//------------------------------------------------------------------------------------------

	doCopy() {
		
		var html = this.packageLinkClipboardMailHtmlContent()
		var _this = this

		this.$copyText(html).then(function (e) {
			
			//console.log(e)
			
			//alert('Copied')
			_this.toast('Package link copied to clipboard')

        }, function (e) {
		 
			//alert('Can not copy')
			console.log(e)
			_this.toast('Could not copy, please try again...')
			
		})
		
	},
	
	importCasting(){
		var packagelink = prompt('Please type in the link address (URL) for the package')
		if( !packagelink || !packagelink.length ) return

		var uid = packagelink.replace(this.site_base_url,'').replace('package/','')
		
		var input = { uid, }

		for( var i = 0; i < this.castings.length; i++ ) {
			if( this.castings[i].uid === uid ) {
				this.msg('That package is already in your packages...')
				return
			}
		}

		var _this = this

		this.$store.dispatch('packages_fetch', input)
			.then((response)=>{

				var casting = response.data.data[0]

				casting.items = JSON.parse(casting.items_json)
				delete casting.items_json
				_this.$store.commit('casting_add', casting)
				//_this.$store.commit('set_casting_active_index', _this.$store.state.castings.length-1)

				_this.msg('Package imported to my packages...')

			})
			.catch((response)=>{
				
				_this.msg('Package not found...')

			})

	},

	packageLinkClipboardMailHtmlContent(){
		var html = ''

		/*
		var el = document.querySelector('.package-linker')
		if(el) {
			html = el.outerHTML
			return html
		}
		*/

		
		

		var title = ''

		var name = this.casting.from_name
		
		var href = this.site_base_url + 'package/' + this.casting.uid

		html += name+' has sent you a package.<br>Click below to view.<br><br>'

		var btn_css = ''

		html += '<a href="'+href+'" style="'+btn_css+'">'
		html += this.casting.uid
		html += '</a>'

		if( this.casting.title ) title = this.casting.title.toUpperCase() + "\r\n"

		var splitter = "- - - - - - - - - - - - - - - - - - - -"

		// alt
		if( name ) html = title + splitter + "\r\n" + name + " has sent you a package. Click here to view your package:" + "\r\n" + href + "\r\n" + splitter
		if( !name ) html = title + splitter + "\r\n" + "A package has been prepared for you. Click here to view your package:" + "\r\n" + href + "\r\n" + splitter

		return html
	},

//------------------------------------------------------------------------------------------

	selectCastingFromList(event){

		this.$store.commit('set_casting_active_index',event.target.value)

		this.active_casting_items_with_metadata = undefined

		this.get_casting_items_metadata()

	},

//------------------------------------------------------------------------------------------		

	get_casting(uid){

		if( !uid ) return

		//this.spinner(true)

		this.$store.dispatch('casting_get', uid)
		.then((casting)=>{
			this.casting = casting
			//this.spinner(false)
		})
		.catch(()=>{
			this.casting = undefined
			//this.toast('Error, could not load casting')
			//this.spinner(false)

			//this.$store.commit('set__my_casting_active_uid',undefined)

		})

	},

//------------------------------------------------------------------------------------------

	clear_casting_items_metadata(){ this.active_casting_items_with_metadata = undefined },

	clear_get_casting_items_metadata(){
		this.clear_casting_items_metadata()
		this.get_casting_items_metadata()
	},

	get_casting_items_metadata(){

		if( !this.casting ) return

		this.$store.dispatch('casting_items_append_metadata', this.casting.items)
		.then((items)=>{
			this.active_casting_items_with_metadata = items			
		})
		.catch(()=>{
			this.toast(['Error, could not load casting','bottom-right','error'])
		})
		.finally(()=>{
			this.spinner(0)
		})

	},	

//------------------------------------------------------------------------------------------

		removeItem: function(input)
		{			
			var sure = confirm('Are you sure?')
			if(!sure) return

			var item_i = input.item_i
			this.$store.commit('casting_item_remove', item_i)
			this.saveCastingSilently()
			this.spinner(1)
			this.get_casting_items_metadata()
		},

		removeItemGroup(input)
		{			
			var sure = confirm('Are you sure?')
			if(!sure) return
			var type = input.type
			var id = input.id
			this.$store.commit('casting_items_remove_all_by', { type, id })
			this.saveCastingSilently()
			this.spinner(1)
			this.get_casting_items_metadata()
		},

		sendCastingClick: function()
		{
			
			if( !this.casting.to_email || !this.casting.to_email.length || !helpers.validateEmail(this.casting.to_email) ) {
				this.msg('Please type a valid recipient email so we know who to send to')
				return
			}

			//var to_email = prompt('Recipient email?')
			//if( !to_email || !to_email.length ) return

			//this.sending_to_email = to_email

			var _this = this

			this.saveCastingToServer({
				onSuccess(){

					_this.sendCastingEmail({
						onSuccess(){
							_this.msg('Package was sent.')
						},
						onError(error){
							_this.msg('Package could not be sent, please try again...')
						},
					})

				},
				onError(error){
					_this.msg('Package could not be sent, please try again...')
				},
			})

		},

		saveCastingSilently(){
			var _this = this
			this.saveCastingToServer({
				onSuccess(){
					//_this.msg('Package saved')
					//_this.triggerIconSignal('check')
					//console.log('casting-saved')
				},
				onError(error){
					_this.toast('Could not save package - please try again...')
				},
			})
		},

		
		saveCastingClick()
		{			

			var _this = this

			if(  this.casting.title  ) var title = 'Package: ' + this.casting.title
			if( !this.casting.title  ) var title = 'Package'

			this.saveCastingToServer({
				onSuccess(){
					//_this.msg('Package saved')
					_this.triggerIconSignal('check')
					_this.toast({ text:title+' was saved', position:'bottom-left' })
				},
				onError(error){
					_this.msg('Could not save package - please try again...')
				},
			})

			//this.triggerIconSignal('check')
		},

		saveCastingToServer(settings){

			var _this = this
			var casting = JSON.parse(JSON.stringify(this.casting))			

			this.fetch( 'casting_save', { casting }, 
			{ onSuccess: function(output){
				if( settings.onSuccess ) settings.onSuccess(output)				
			}, onError: function(output){
				if( settings.onError ) settings.onError(output)				
			}})

		},


		sendCastingEmail(settings){

			var _this = this
			
			var realm = 'scoopmodels'
			if( this.is_site_am ) realm = 'amanagement'

			this.fetch( 'casting_send_email', { uid: this.casting.uid, realm:realm, to_email: this.sending_to_email }, 
			{ onSuccess: function(output){
				if( settings.onSuccess ) settings.onSuccess(output)				
			}, onError: function(output){
				if( settings.onError ) settings.onError(output)				
			}})

		},


		printCastingClick: function()
		{

			this.msg('print'); return
			
			var input = {
				casting: this.casting,
			}

			$.post(Site.url + 'casting/pdf', input, function(output){
				
				var filename = 'casting'+ parseInt(Math.random()*1000) +'.pdf'

				download(output, filename, 'application/pdf')
				
			})

		},


		createNewCastingClick: function()
		{					
		
			//var saveCurrent = confirm('Save current casting?')
			//if(!saveCurrent) return
			
			this.$store.commit('create_new_empty_casting')
			
			var index = this.castings.length -1
			if( index < 0 ) index = 0
			this.$store.commit('set_casting_active_index', index)
			//this.msg('New package created')
			this.toast(['New package created','bottom-left'])

			this.active_casting_items_with_metadata = undefined
			
		},

		removeCastingClick: function()
		{
			var sure = confirm('Are you sure?')
			if(!sure) return

			var casting = {...this.casting}

			if(  casting.title ) var title = 'Package: ' + casting.title
			if( !casting.title ) var title = 'Package'


			var index = this.casting_active_index
			this.$store.commit('delete_casting', index)

			if( !this.$store.state.castings.length ) this.$store.commit('create_new_empty_casting') // create empty casting if last one deleted - so as not to have empty list
			
			this.triggerIconSignal('check')

			this.toast([ title+' was removed', 'bottom-left' ])

			// ajax delete it as well?

			var deletefromserver = confirm('The package was removed from your list. Do you want to delete entirely for other users as well?')

			if( deletefromserver ) {
				
				this.$store.dispatch('casting_delete',casting)
					.then(()=>{
						this.toast([title+' was deleted', 'bottom-left'])
					})
					.catch(()=>{
						this.toast([title+' could not be deleted', 'bottom-left', 'error'])
					})
			}


		},

		orEmpty: function(input){
			if( input === undefined ) return '-';
			if( input === null ) return '-';
			return input
		},

		updateCasting(){
			var casting_index = 0
			var patch = {
				title: this.$refs.title.value,
				to_name: this.$refs.to_name.value,
				to_email: this.$refs.to_email.value,
				from_name: this.$refs.from_name.value,
				from_email: this.$refs.from_email.value,
				notes: this.$refs.notes.value,
			}		
			this.$store.commit('update_casting', { index:casting_index, patch } )
			this.saveCastingSilently()
		},

		item_preview_css(item) {
			var css = {}
			if( item.media && ( item.media.type == 'youtube' || item.media.type == 'vimeo' ) ) css['background-color'] = '#EEE'
			if( item.media && item.media.dominant_color ) css['background-color'] = '#' + item.media.dominant_color
			return css
		},

	},

	watch: {

		//casting_active_index(){
		//	console.log(this.casting_active_index)
		//	this.$refs.castingselector.value = this.casting_active_index
		//},	

	},

	created(){
		
		if( !this.$store.state.castings.length ) this.$store.commit('create_new_empty_casting')

		this.get_casting_items_metadata()
		
	},

	mounted(){

	},

}
</script>



// WEBPACK FOOTER //
// src/views/Casting.vue